import { apiUrl } from '../../../config/api';
export async function fetchPartidoById(partidoId) {
    const fetchedData = await fetch(apiUrl('partidos/') + partidoId);
    return fetchedData.json();
}
